module.exports = __webpack_public_path__ + "static/media/Lashes02.dc402ae1.jpeg";